import React, { FC, useState } from 'react';
import s from './info.module.scss';
import { SpriteIcon } from '@components/Sprites/SpriteIcon';
import { Dictionary, useTranslation } from '@hooks/useTranslation';
import { CustomTooltip } from '@components/UIKit/CustomTooltip/CustomTooltip';
import dynamic from 'next/dynamic';
const InfoModal = dynamic(import('@components/Modals/Variants/Info/Info').then(module => module.InfoModal), {
  ssr: false
});
const Modal = dynamic(import('@components/Modals/Modal').then(module => module.Modal), {
  ssr: false
});
type InfoProps = {
  id: string;
  tooltip: Dictionary;
  isMobile: boolean;
};
export const Info: FC<InfoProps> = ({
  id,
  tooltip,
  isMobile
}) => {
  const {
    translate: tr
  } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const closeHandler = () => {
    setIsOpen(false);
  };
  const openHandler = () => {
    isMobile && setIsOpen(true);
  };
  return <div className={s.typeInfo} data-tooltip-id={id} data-sentry-component="Info" data-sentry-source-file="Info.tsx">
            <SpriteIcon onClick={openHandler} className={s.info__icon} name='info' color='var(--Nl-Blue)' data-sentry-element="SpriteIcon" data-sentry-source-file="Info.tsx" />
            {!isMobile && <CustomTooltip id={id} className={s.typeInfo__wrapper}>
                    {tr({
        id: tooltip
      })}
                </CustomTooltip>}

            <Modal isOpen={isOpen} onClose={closeHandler} data-sentry-element="Modal" data-sentry-source-file="Info.tsx">
                <InfoModal closeHandler={closeHandler} text={tooltip} data-sentry-element="InfoModal" data-sentry-source-file="Info.tsx" />
            </Modal>
        </div>;
};